<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            submit-button-text="Update Account"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :title="title"
            :subtitle="subtitle"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <input-text
            name="name"
            label="Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
        />

        <input-text
            name="password"
            label="Password (leave empty to not change it)"
            type="password"
            v-model="form.password"
            :error="errors.password ? errors.password[0] : null"
            class="mt-3"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "AccountForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                password: this.getFormData("password"),
            },
        };
    },
};
</script>
